<script>
import qs from "qs";
import axios from "axios";
import { provide } from "vue";
import Header from "./components/header.vue";
import Footer from "./components/footer.vue";
export default {
  name: "App",
  components: { Header, Footer },
  data() {
    return {
      isMobile: false, //默认为pc端
      user: {
        username: "admin",
        password: "123456",
      },
      screenWidth: "",
      screenHeight: "",
      prevScrollPos: 0,
      showHeader: true,
      isMac: false,
      isWindows: false,
      currentZoom: "",
    };
  },
  created() {},
  mounted() {
    // 滚动显示头部
    window.addEventListener("scroll", this.handleScroll);
    var lastVisitedPage = localStorage.getItem("a");
    if (lastVisitedPage) {
      window.location.href = lastVisitedPage;
      localStorage.removeItem("a");
    }

    // this.request.get(`/1/1`).then(res => {
    //   console.log(res);
    //   if (res.code == 401) {
    //     sessionStorage.removeItem("start");
    //     this.login();
    //   }
    // });
    try {
      this.request.get(`/1/1`).then((res) => {
        console.log(res);
        if (res.code == 401) {
          sessionStorage.removeItem("start");
          this.login();
        }
      });
    } catch (error) {
      console.log("error", error);
    }

    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    //

    // document.addEventListener("wheel", function(event) {
    //   this.currentZoom = window.devicePixelRatio;
    //   console.log("当前缩放比例", window.devicePixelRatio, this.currentZoom);

    //   if (window.devicePixelRatio >= 2) {
    //     console.log("警报警报");
    //   }
    // });

    // 浏览器缩放比例
    // this.handleWheelEvent(); // 自动执行一次事件处理逻辑
    // document.addEventListener("wheel", this.handleWheelEvent);

    //
    if (flag) {
      //如果flag不为空，说明可以匹配到，是手机端
      this.isMobile = true;
      window.location.href = "https://m.szce.com";
      console.log("isMobile");
    }

    this.screenWidth = document.body.clientWidth;
    this.screenHeight = document.body.clientHeight;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
        this.screenHeight = document.body.clientHeight;
        if (this.screenWidth < 900) {
          localStorage.setItem("a", window.location.href);
          window.location.href = "https://m.szce.com/";
          console.log("isMobile");
        } else {
          this.currentZoom = window.devicePixelRatio;
          if (this.currentZoom > 2) {
            // window.location.href = "http://localhost:8081/";
          }
          console.log("isPC", this.screenWidth, this.currentZoom);
        }
      })();
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    login() {
      axios({
        url: "https://www.szce.com/api/login",

        method: "post",
        data: qs.stringify(this.user),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }).then((res) => {
        console.log(res.data.data.token);
        localStorage.setItem("token", res.data.data.token);
        this.$router.push({ path: "/" });
      });
    },
    // 滚动显示头部
    handleScroll() {
      const currentScrollPos = window.scrollY;
      if (this.prevScrollPos > currentScrollPos) {
        this.showHeader = true;
      } else {
        this.showHeader = false;
      }
      this.prevScrollPos = currentScrollPos;
    },
    // 浏览器缩放比例
    handleWheelEvent(event) {
      // this.currentZoom = window.devicePixelRatio;
      console.log("当前缩放比例", this.currentZoom);
    },
  },
};
</script>

<template>
  <div id="app" class="appContainer">
    <!-- <Header :class="{ active: showHeader }"></Header> -->
    <!-- <Header
      :class="{
        active: showHeader,
        normal: prevScrollPos == 0 && showHeader,
        hidden: !showHeader
      }"
    ></Header> -->
    <transition name="header-fade">
      <Header
        v-if="showHeader"
        :class="{
          active: showHeader,
          normal: prevScrollPos == 0 && showHeader,
        }"
        key="header"
      ></Header>
    </transition>

    <!-- <div class="navbar">
                    <a > <router-link :to="{path:'/webindex'}"> <img class="szce" src="./assets/img/logo_w@2x.png" alt=""> </router-link></a>
                    <div class="nav">
                        <ul>
                            <li>
                                <a href="index.html" class="a">关于昌恩<img src="./assets/img/index/icon_pull down@2x.png" alt=""></a>
                                <ol class="ol">
                                    <li><router-link :to="{path:'/introduction'}" class="b">集团架构</router-link > </li>
                                    <li><router-link :to="{path:'/projects'}" class="b">案例展示</router-link></li>
                                    <li><router-link :to="{path:'/qualification'}"  class="b">资质中心</router-link></li>
                                    <li><router-link :to="{path:'/ceo'}"  class="b">董事长致辞</router-link></li>
                                </ol>
                            </li>
                            <li>
                                <a href="buliding.html" class="a">主营业务<img src="./assets/img/index/icon_pull down@2x.png" alt=""></a>
                                <ol class="ol">
                                    <li>
                                        <a href="buliding.html" class="b">建筑智能化</a>
                                        <ol>
                                            <li><a href="./Intelligent-security.html">智能安防</a></li>
                                            <li><a href="buliding.html">建筑智能管理</a></li>
                                                                <li><a href="./air-conditioning.html">中央空调节能智控</a></li>
                                        </ol>
                                    </li>
                                    <li>
                                        <a href="traffic.html" class="b">智慧交通</a>
                                        <ol>
                                            <li><a href="./traffic3.html">科技治超</a></li>
                                            <li><a href="./traffic2.html">道路监控</a></li>
                                            <li><a href="./traffic1.html">运营车辆管理</a></li>
                                        </ol>
                                    </li>
                                </ol>
                            </li>
                            <li><router-link :to="{path:'/newscenter'}" class="a">新闻中心</router-link > </li>
                            <li><router-link :to="{path:'/contact'}" class="a">联系我们</router-link></li>
                        </ul>
                    </div>
                    </div> -->
    <router-view></router-view>

    <!-- <Footer></Footer> -->
  </div>
</template>

<style>
img {
  border: 0 !important;
}
</style>

<style lang="less" scoped>
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

.active {
  position: fixed !important;
  top: 0; /* 激活状态，将头部显示在视口顶部 */
  // top: -100px; /* 初始状态，将头部隐藏在视口上方 */
  width: 100%;
  // transition: top 0.3s ease-in-out; /* 平滑过渡效果 */
  background-color: #030e2c;
  z-index: 20 !important;
  animation: showHeaderEl 1s linear;
}

@keyframes showHeaderEl {
  from {
    top: -100px;
    opacity: 0;
  }

  to {
    top: 0;
    opacity: 1;
  }
}

.header-fade-enter-active {
  transition: opacity 0s;
}
.header-fade-leave-active {
  transition: opacity 0.2s;
}
.header-fade-leave-active {
  animation: hiddenHeaderEl linear 0.2s;
}
.header-fade-enter, .header-fade-leave-to /* .header-fade-leave-active 在 <transition> 中定义 */ {
  opacity: 0;
}

@keyframes hiddenHeaderEl {
  from {
    top: 0px;
    opacity: 1;
  }

  to {
    top: -100px;
    opacity: 0;
  }
}
// .hidden {
//   position: fixed !important;
//   top: -100px !important; /* 初始状态，将头部隐藏在视口上方 */
//   width: 100%;
//   background-color: #030e2c;
//   z-index: 20 !important;
//   animation: hiddenHeaderEl linear 0.5s;
// }

.normal {
  background-color: rgba(0, 0, 0, 0) !important;
}

// .appContainer{
//   position: relative;
// }
// .blankdiv{
//     width: 100%;
//     height: .417rem;
//     position: absolute;
//     z-index: 3;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue